
const sortHelper = (key, objL, objR) => {
    let nameA = objL[key].toUpperCase();
    let nameB = objR[key].toUpperCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};

const ArrayUtils = {
    sortHelper
};

export default ArrayUtils;